<template>
<div>
<AllFinancial/>

</div>
</template>

<script>
import AllFinancial from "../../components/Financial/AllFinancial.vue";


export default {
  components: {
   AllFinancial
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {
  }
};
</script>

<style scoped>


</style>